export default {
    title: 'Vos résultats',
    text: 'Pour obtenir vos résultats, rentrez vos coordonnées et restons en contact !',
    acceptation: 'J\'accepte d\'être inscrite à la newsletter',
    spam: 'Pas de spam ou de courrier indésirable, votre adresse email ne sera utilisée que pour le résultat du quiz et pour la newsletter',
    sentByEmail: 'Pour davantage de détails, n\'hésitez pas à prendre rendez-vous ci dessous.',
    introduction: 'Votre corps et ses symptômes nous enseignent beaucoup de choses !\n' +
        'Si vous avez rempli mon quizz sur la santé hormonale, il y a de fortes chances que vous souffriez de symptômes de dérèglement hormonal que vous cherchez à appréhender. Vous êtes au bon endroit !\n' +
        'Mon objectif est de vous aider à mieux comprendre ce que vos symptômes indiquent, et de vous donner des clés pour commencer à rééquilibrer vos hormones naturellement.',
    maxNumberOfResults: 1,
    noSymptom: {
        text: 'Félicitations, vous n\'avez pas l\'air d\'avoir de symptômes trop prononcés, vous êtes bien équilibrée sur le plan hormonal !',
        family: 'Pas assez de symptômes',
        icon: 'mdi-heart',
    },
    littleSymptoms: {
        text: 'il est donc peu probable que cette catégorie soit responsable des symptômes que vous ressentez.',
        icon: 'mdi-emoticon-happy',
    },
    mediumSymptoms: {
        text: 'donc cette catégorie mérite votre attention, car cette hormone est probablement responsable de certains de vos symptômes.',
        icon: 'mdi-emoticon-neutral',
    },
    heavySymptoms: {
        text: 'cela signifie donc que c\'est sûrement un problème lié à cette hormone qui génère la plupart de vos symptômes.',
        icon: 'mdi-emoticon-sad',
    },
    actions: {
        name: {
            text: 'Prénom & Nom',
            type: 'text',
            color: 'white',
            icon: 'mdi-account-circle',
        },
        email: {
            text: 'Email',
            type: 'email',
            color: 'white',
            icon: 'mdi-email',
        },
        submit: {
            text: 'Voir mes résultats',
            type: 'text',
            color: 'white',
        },
        buttons: [{
            text: 'Réserver une consultation',
            type: 'button',
            color: 'white',
            url: 'https://docs.google.com/forms/d/144Aw8IivNJy93mtZxk1uR0UFJSATQP4t0Z3kELsxQcg/viewform',
        },],
    },
};
